import React, {Key, useEffect, useState} from "react";
import {
    Breadcrumb,
    Button,
    Col,
    Collapse,
    DatePicker,
    Form,
    Image,
    Layout,
    List,
    Modal,
    Pagination,
    Row,
    Space,
    Table,
    Tabs,
    Tree
} from "antd";
import Sider from "antd/es/layout/Sider";
import {Content} from "antd/es/layout/layout";
import styled from "styled-components";
import Input from "antd/es/input/Input";
import {useStore} from "../../store";
import {observer} from "mobx-react";
import {ColumnsType} from "antd/lib/table";
import {TableDisplayEnum} from "../../entity/enum/home";
import PlantDetail from "../detail/plant-detail";
import {getBaseTreeApi, getSpecimenList} from "../../http/home";
import {reject} from "lodash";
import {TreeData} from "../../entity/tree-data";
import {TreeEntity} from "../../entity/tree-entity";
import {showFullScreenLoading, tryHideFullScreenLoading} from "../../config/serviceLoading";
import {SpecimenEntity} from "../../entity/specimen-entity";
import {transaction} from "mobx";
import "../../css/table.css";
import {DownOutlined, RedoOutlined, SearchOutlined, UpOutlined} from "@ant-design/icons";
import "../../css/global.css"
import {BaseImageUrl} from "../../http/http";

const defaultIcon = require("../../image/default-pic.png")

const columns: ColumnsType<SpecimenEntity> = [
    {
        title: "序号",
        width: 50,
        dataIndex: 'key',
        key: 'key',
        align: "center",
        className: "key",
        render: (value, record, index) => {
            return <div>{index + 1}</div>
        }
    },
    {
        title: '馆藏条码',
        width: 100,
        dataIndex: 'libraryCode',
        key: 'libraryCode',
        align: "center",
        className: "tabeTitle",
        render: (value, record, index) => {
            return <div>{`${record.libraryCode}${record.barCode}`}</div>
        }
    },
    {
        title: '中文名/学名',
        width: 100,
        dataIndex: 'specimenName',
        key: 'specimenName',
        align: "center",
        className: "tabeTitle",
    },
    {
        title: '采集地',
        width: 200,
        dataIndex: 'province',
        key: 'province',
        render: (value, record, index) => {
            return <div>{`${record.province}/${record.district}`}</div>
        },
        align: "center",
        className: "tabeTitle",
    },
    {
        title: '采集人/采集号',
        width: 200,
        dataIndex: 'gatherer',
        key: 'gatherer',
        align: "center",
        className: "tabeTitle",
        render: (value, record, index) => {
            return <div>{`${record.gatherer}/${record.gatherNumber}`}</div>
        }
    },
    {
        title: '采集日期',
        width: 100,
        dataIndex: 'gatherDate',
        key: 'gatherDate',
        align: "center",
        className: "tabeTitle",
        sorter: false
    },
    {
        title: '鉴定人',
        width: 100,
        dataIndex: 'authenticateEr',
        key: 'authenticateEr',
        align: "center",
        className: "tabeTitle",
    },
    {
        title: '鉴定日期',
        width: 100,
        dataIndex: 'authenticateDate',
        key: 'authenticateDate',
        align: "center",
        className: "tabeTitle",
    },
];
const ListTypeTabs = [
    {key: "list", label: "列表展示"},
    {key: "image", label: "卡片展示"},
]
const dataList: TreeEntity[] = [];
const PlantClassify: React.FC = () => {
    const store = useStore();
    const [form] = Form.useForm();
    useEffect(() => {
        getBaseTree();
        queryClassifyList({});
        return clear;
    }, []);

    const {classifyListStore} = store;
    const [expandedKeys, setExpandedKeys] = useState<React.Key[]>([]);
    const [searchValue, setSearchValue] = useState('');
    const [autoExpandParent, setAutoExpandParent] = useState(true);

    const renderItem = (item: any) => {
        return <List.Item style={{minWidth: "400px"}}>
            <CardWrapper onClick={() => {
                onItemClick(item)
            }}>
                <div style={{display: "flex", flexDirection: "row", padding: "5px 20px 10px 5px"}}>
                    {/*<LazyLoadImage effect={"blur"} style={{width:"100px", height:"100px", margin:"15px 20px 10px 15px"}} src={BaseImageUrl+item.imgUrl}/>*/}
                    <Image
                        style={{width: "100px", height: "100px", margin: "15px 20px 10px 15px", pointerEvents: "none"}}
                        src={BaseImageUrl + item.imgUrl} fallback={defaultIcon} preview={false}/>
                    {/*<img   key={item.id} style={{width:"100px", height:"100px", margin:"15px 20px 10px 15px", pointerEvents:"none"}} src={getThumbImageUrl(item.imgUrl)}  loading={"lazy"}/>*/}
                    <CardContent>
                        <span>{item.specimenName}</span>
                        <span>{`馆藏条码号:${item.libraryCode}${item.barCode}`}</span>
                        <span>{`采集人：${item.gatherer}`}</span>
                        <span>{`采集地点：${item.province}${item.district}`}</span>
                        <span>{`采集时间：${item.gatherDate}`}</span>
                    </CardContent>
                </div>
            </CardWrapper>
        </List.Item>
    }

    const onExpendClick = () => {
        const fields = form.getFieldsValue;
        const isExpend = classifyListStore.isExpend;
        classifyListStore.setExpend(!isExpend);
        form.setFieldsValue(fields);
    }
    const clear = () => {
        classifyListStore.clear();
    }
    const onRadioChange = (e: string) => {
        if (classifyListStore.displayType === e) {
            return
        }
        transaction(() => {
            classifyListStore.dataSource = [];
            classifyListStore.setDisplayType(e);
            onQuery()
        })
    }
    const onItemClick = (item: any) => {
        classifyListStore.setPlantDetail(item);
        classifyListStore.setDetailModalOpen(true);
    }
    const onClose = () => {
        classifyListStore.setDetailModalOpen(false);
    }
    const getBaseTree = () => {
        showFullScreenLoading()
        getBaseTreeApi({})
            .then((res) => {
                tryHideFullScreenLoading()
                if (res && res.data && res.data.length > 0) {
                    convertTreeData(res.data);
                } else {
                    reject("1");
                }
            }).catch(() => {
            tryHideFullScreenLoading()
        }).catch((e) => {
            console.log("error:" + e.message)
        });
    }

    const queryClassifyList = (params: any) => {
        getSpecimenList(params)
            .then((res) => {
                tryHideFullScreenLoading();
                classifyListStore.pagination.total = res.data ? res.data.total : 0;
                refreshTableData((res.data && res.data.list && res.data.list.length > 0) ? res.data.list : []);
            }).catch(() => {
            tryHideFullScreenLoading();
        })
    }

    const refreshTableData = (data: SpecimenEntity[]) => {
        const list: SpecimenEntity[] = [];
        data.forEach((item) => {
            item.key = String(item.id);
            list.push(item);
        })
        classifyListStore.setDataSource(list);
    }

    const convertTreeData = (list: TreeData[]) => {
        const treeList: TreeEntity[] = [];
        list.forEach((first) => {
            const firstEntity = new TreeEntity();
            firstEntity.title = first.species_family_name;
            firstEntity.label = first.species_family_name;
            firstEntity.key = first.species_family;
            firstEntity.type = 1;
            firstEntity.children = [];
            dataList.push(firstEntity);
            if (first.genus.length > 0) {
                first.genus.forEach((second) => {
                    const secondEntity = new TreeEntity();
                    secondEntity.title = second.genus_name;
                    secondEntity.label = second.genus_name;
                    secondEntity.key = second.genus;
                    secondEntity.type = 2;
                    secondEntity.children = [];
                    dataList.push(secondEntity);
                    if (second.species.length > 0) {
                        second.species.forEach((third) => {
                            const thirdEntity = new TreeEntity();
                            thirdEntity.title = third.canonical_name + " " + third.species_zh_name;
                            thirdEntity.label = third.canonical_name + " " + third.species_zh_name;
                            thirdEntity.key = third.species;
                            thirdEntity.type = 3;
                            dataList.push(thirdEntity);
                            secondEntity.children.push(thirdEntity);
                        })
                    }
                    firstEntity.children.push(secondEntity)
                })
            }
            treeList.push(firstEntity)
        })
        classifyListStore.treeList = treeList;
    }
    const onTreeSelect = (selectkeys: Key[], info: any) => {
        if (selectkeys.length <= 0) {
            return;
        }
        const selectKey = selectkeys[0];
        const selectTreeList: TreeEntity[] = [];
        classifyListStore.treeList.forEach((first) => {
            if (first.key === selectKey) {
                selectTreeList.push(createNewTreeEntity(first));
            } else {
                first.children.forEach((second) => {
                    if (second.key === selectKey) {
                        const new1 = createNewTreeEntity(first);
                        const new2 = createNewTreeEntity(second);
                        selectTreeList.push(new1);
                        selectTreeList.push(new2);
                    } else {
                        second.children.forEach((third) => {
                            if (third.key === selectKey) {
                                const new11 = createNewTreeEntity(first);
                                const new12 = createNewTreeEntity(second);
                                const new13 = createNewTreeEntity(third);
                                selectTreeList.push(new11);
                                selectTreeList.push(new12);
                                selectTreeList.push(new13);
                            }
                        })
                    }
                })
            }
        })
        classifyListStore.setSelectTreeEntity(info.node)
        // classifyListStore.setSelectTreeList(selectTreeList);
        onQuery();
    }

    const renderBreadcrumb = () => {
        return classifyListStore.selectTreeList.map((item) => {
            return <Breadcrumb.Item key={item.key}>{item.label}</Breadcrumb.Item>
        })
    }

    const createNewTreeEntity = (data: TreeEntity) => {
        const newEntity = new TreeEntity();
        newEntity.title = data.title;
        newEntity.label = data.label;
        newEntity.key = data.key;
        newEntity.type = data.type;
        newEntity.children = [];
        return newEntity;
    }

    const onRest = () => {
        classifyListStore.resetQuery();
        form.setFieldsValue(classifyListStore.condition);
        onQuery();
    }

    const onQuery = () => {
        let gatherDateStart = "";
        let gatherDateEnd = "";
        if (form.getFieldValue("gatherDate") && form.getFieldValue("gatherDate").length > 1) {
            gatherDateStart = form.getFieldValue("gatherDate")[0].format("YYYY-MM-DD");
            gatherDateEnd = form.getFieldValue("gatherDate")[1].format("YYYY-MM-DD");
        }
        const params = {
            libraryCode: form.getFieldValue("libraryCode"),
            specimenName: form.getFieldValue("specimenName"),
            gatherer: form.getFieldValue("gatherer"),
            gatherDateStart: gatherDateStart,
            gatherDateEnd: gatherDateEnd,
            gatherNumber: form.getFieldValue("gatherer"),
            province: form.getFieldValue("province"),
            district: form.getFieldValue("province"),
            pageNum: classifyListStore.pagination.pageNum,
            pageSize: classifyListStore.pagination.pageSize,
            specimenFamily: "",
            specimenGenus: "",
            specimenSpecies: "",
        }
        if (classifyListStore.selectedTree) {
            if (classifyListStore.selectedTree.type === 1) {
                params.specimenFamily = classifyListStore.selectedTree.key;
            } else if (classifyListStore.selectedTree.type === 2) {
                params.specimenGenus = classifyListStore.selectedTree.key;
            } else if (classifyListStore.selectedTree.type === 3) {
                params.specimenSpecies = classifyListStore.selectedTree.key;
            }
        }
        // if (classifyListStore.selectTreeList.length === 1) {
        //     params.specimenFamily = classifyListStore.selectTreeList[0].key;
        // } else if (classifyListStore.selectTreeList.length === 2) {
        //     params.specimenGenus = classifyListStore.selectTreeList[1].key;
        // } else if (classifyListStore.selectTreeList.length === 3) {
        //     params.specimenSpecies = classifyListStore.selectTreeList[2].key;
        // }
        showFullScreenLoading()
        queryClassifyList(params);
    }

    const onLibraryChange = (e: any) => {
        classifyListStore.condition.libraryCode = e.target.value;
    }

    const onNameChange = (e: any) => {
        classifyListStore.condition.specimenName = e.target.value;
    }

    const onAreaChange = (e: any) => {
        classifyListStore.condition.province = e.target.value;
        classifyListStore.condition.district = e.target.value;
    }

    const onPersonChange = (e: any) => {
        classifyListStore.condition.gatherer = e.target.value;
        classifyListStore.condition.gatherNumber = e.target.value;
    }

    const onDateChange = (values: any, formatString: [string, string]) => {
        classifyListStore.condition.gatherDateStart = formatString[0];
        classifyListStore.condition.gatherDateEnd = formatString[1];
    }

    const onSizeChange = (page: any, pageSize: any) => {
        classifyListStore.pagination.pageSize = pageSize;
        classifyListStore.pagination.pageNum = page;
        onQuery();
    }

    const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const {value} = e.target;
        const newExpandedKeys = dataList
            .map((item) => {
                if (item.label && item.label.indexOf(value) > -1) {
                    return getParentKey(item.key, classifyListStore.treeList);
                }
                return null;
            })
            .filter((item, i, self) => item && self.indexOf(item) === i);
        transaction(() => {
            setSearchValue(value);
            setExpandedKeys(newExpandedKeys as React.Key[]);
            setAutoExpandParent(true);
            convertTreeDataBySearch(value);
        })

    };

    const convertTreeDataBySearch = (value: string) => {
        const {treeList} = classifyListStore;
        treeList.forEach((first) => {
            const strTitle = first.label;
            const index = strTitle.indexOf(value);
            const beforeStr = strTitle.substring(0, index);
            const afterStr = strTitle.slice(index + value.length);
            const title =
                index > -1 ? (<span>{beforeStr}
                    <HighLightSpan className="site-tree-search-value">{value}</HighLightSpan>
                    {afterStr}</span>) : (<span>{strTitle}</span>);
            first.title = title;
            if (first.children && first.children.length > 0) {
                first.children.forEach((second) => {
                    if (second.label) {
                        const strTitle = second.label;
                        const index = strTitle.indexOf(value);
                        const beforeStr = strTitle.substring(0, index);
                        const afterStr = strTitle.slice(index + value.length);
                        const title =
                            index > -1 ? (<span>{beforeStr}
                                <HighLightSpan className="site-tree-search-value">{value}</HighLightSpan>
                                {afterStr}</span>) : (<span>{strTitle}</span>);
                        second.title = title;
                    }
                    if (second.children && second.children.length > 0) {
                        second.children.forEach((third) => {
                            if (third.label) {
                                const strTitle = third.label;
                                const index = strTitle.indexOf(value);
                                const beforeStr = strTitle.substring(0, index);
                                const afterStr = strTitle.slice(index + value.length);
                                const title =
                                    index > -1 ? (<span>{beforeStr}
                                        <HighLightSpan className="site-tree-search-value">{value}</HighLightSpan>
                                        {afterStr}</span>) : (<span>{strTitle}</span>);
                                third.title = title;
                            }
                        })
                    }
                })
            }
        })
    }

    const getParentKey = (key: React.Key, tree: TreeEntity[]): React.Key => {
        let parentKey: React.Key;
        for (let i = 0; i < tree.length; i++) {
            const node = tree[i];
            if (node.children) {
                if (node.children.some((item) => item.key === key)) {
                    parentKey = node.key;
                } else if (getParentKey(key, node.children)) {
                    parentKey = getParentKey(key, node.children);
                }
            }
        }
        return parentKey!;
    };

    const onExpand = (newExpandedKeys: React.Key[]) => {
        setExpandedKeys(newExpandedKeys);
        setAutoExpandParent(false);
    };

    const FirstLevelSearch = () => {
        return (
            <Form form={form} labelAlign={"right"} style={{maxWidth: "none", padding: "5px"}} wrapperCol={{span: "15"}}><Row>
                <Col span={6} offset={1}><Form.Item labelCol={{span: "7"}} name={"libraryCode"}
                                                    label={"馆藏条码"}><Input onChange={onLibraryChange}
                                                                              value={classifyListStore.condition.libraryCode}/></Form.Item></Col>
                <Col span={6} offset={1}><Form.Item labelCol={{span: "7"}} name={"specimenName"}
                                                    label={"中文名/学名"}><Input onChange={onNameChange}
                                                                                 value={classifyListStore.condition.specimenName}/></Form.Item></Col>
                <Col span={6} offset={1}><Form.Item labelCol={{span: "7"}} name={"gatherDate"}
                                                    label={"采集日期"}><DatePicker.RangePicker format={"YYYY-MM-DD"}
                                                                                               onChange={onDateChange}/></Form.Item></Col>
                <Col span={3}><Button onClick={onExpendClick}
                                      icon={classifyListStore.isExpend ? <UpOutlined/> : <DownOutlined/>}
                                      type={"link"}>{classifyListStore.isExpend ? "折叠" : "展开"}</Button></Col>
            </Row></Form>)
    }

    const SecondLevelSearch = () => {
        return (<Form form={form} labelAlign={"right"} style={{maxWidth: "none"}} wrapperCol={{span: "15"}}><Row>
            <Col span={6} offset={1}><Form.Item name={"gatherer"} labelCol={{span: "7"}} label={"采集人/采集号"}><Input
            /></Form.Item></Col>
            <Col span={6} offset={1}><Form.Item name={"province"} labelCol={{span: "7"}} label={"采集地 "}><Input
                value={classifyListStore.condition.province}
                onChange={onAreaChange}/></Form.Item></Col>
            <Col span={6} offset={1}/>
            <Col span={3}/>
        </Row></Form>)
    }

    return (<Wrapper>
            <Layout style={{padding: "0"}}>
                <Sider theme={"light"} width={"220px"}
                       style={{background: "white", paddingRight: "15px", paddingLeft: "20px"}}>
                    <Input prefix={<SearchOutlined/>} size={"middle"} placeholder={"输入物种分类"}
                           style={{marginTop: "20px", marginBottom: "20px", fontSize: "14px", color: "#333"}}
                           onChange={onChange}/>
                    <div style={{overflow: "scroll", height: "86%"}}>
                        <Tree
                            onExpand={onExpand}
                            expandedKeys={expandedKeys}
                            autoExpandParent={autoExpandParent}
                            onSelect={onTreeSelect}
                            treeData={classifyListStore.treeList}/>
                    </div>
                </Sider>
                <Content>
                    <SearchWrapper>
                        <SearchTitleWrapper>
                            <div className={"searchTitle"}>查询区域</div>
                            <Space className={"searchButton"} size={"small"} align={"start"} direction={"horizontal"}>
                                <Button icon={<SearchOutlined/>} onClick={onQuery} type={"primary"}>查询</Button>
                                <Button icon={<RedoOutlined/>} onClick={onRest} ghost={true}
                                        type={"primary"}>重置</Button>
                            </Space>
                        </SearchTitleWrapper>
                        <Line/>
                        <Collapse
                            activeKey={classifyListStore.isExpend ? ['1'] : ["0"]}
                            defaultActiveKey={['0']} ghost>
                            <Collapse.Panel collapsible={"icon"} showArrow={false} key={1} header={<FirstLevelSearch/>}>
                                <SecondLevelSearch/>
                            </Collapse.Panel>
                        </Collapse>
                    </SearchWrapper>

                    <ContentWrapper>
                        <Tabs onChange={onRadioChange} defaultActiveKey={"list"} type={"card"} size={"small"}
                              items={ListTypeTabs}/>
                        {classifyListStore.displayType === TableDisplayEnum.List && <Table
                            style={{margin: "0 20px 20px 20px"}}
                            bordered={true}
                            size={"small"}
                            columns={columns}
                            rowClassName={(type, index, intent) => {
                                return index % 2 === 0 ? "tableItemWhite" : "tableItemGray";
                            }}
                            dataSource={classifyListStore.dataSource}
                            onRow={(record) => {
                                return {
                                    onClick: () => onItemClick(record),
                                }
                            }}
                            scroll={{x: 1000, y: 300}}
                            pagination={{position: [], pageSize: classifyListStore.pagination.pageSize}}
                        />}
                        {classifyListStore.displayType === TableDisplayEnum.Card && <div
                            style={{margin: "0 79px", height: "330px", marginBottom: "30px", overflow: "auto"}}>
                            <List
                                grid={{
                                    gutter: 16,
                                    column: 3
                                }} dataSource={classifyListStore.dataSource} renderItem={renderItem}/>
                        </div>}
                        <Pagination
                            size={"small"}
                            style={{margin: "0 20px 20px 0", alignSelf: "end"}}
                            total={classifyListStore.pagination.total}
                            showQuickJumper={true}
                            showSizeChanger={true}
                            defaultPageSize={10}
                            hideOnSinglePage={true}
                            onChange={onSizeChange}
                            current={classifyListStore.pagination.pageNum}
                        />
                    </ContentWrapper>
                </Content>
            </Layout>
            <Modal
                open={classifyListStore.detailModalOpen}
                onCancel={onClose}
                closable={true}
                centered={true}
                destroyOnClose={true}
                title={null}
                footer={null}
                mask={true}
                maskClosable={true}
                width={"1000px"}>
                <PlantDetail detail={classifyListStore.plantDetail}/>
            </Modal>
        </Wrapper>
    );
}

export default observer(PlantClassify)

const Wrapper = styled.div`
  & {
    display: flex;
    flex-direction: column;
    background: #EDEFEF;
    overflow: hidden;

    .ant-list {
      overflow-x: hidden;
    }

    .ant-form-item {
      margin-bottom: 0px;
    }

    .ant-table-wrapper .ant-table-thead > tr > th {
      background: #EFF3F8;
    }

    .ant-collapse .ant-collapse-content > .ant-collapse-content-box {
      padding: 12px 16px 12px 12px;
    }

    .tableItemWhite {
      background: white;
    }

    .tableItemGray {
      background: #F9FAFD;
    }
  }
`;
const CardWrapper = styled.div`
  & {
    display: flex;
    flex-direction: column;
    background: white;
    border: 1px solid #E8EBF2;
    border-radius: 2px;
  }
`;
const CardContent = styled.span`
  & {
    display: flex;
    flex-direction: column;
    justify-content: center;
    font-size: 14px;
    line-height: 20px;
    font-weight: 400;
    color: #666666;

    span:nth-child(1) {
      font-size: 16px;
      line-height: 24px;
      font-weight: 500;
      color: black;
      margin-bottom: 10px;
    }
  }
`;
const CardActionWrapper = styled.div`
  & {
    display: flex;
    flex-direction: row;
    background: white;
    border-style: solid;
    border-color: lightgray;
    border-width: 1px 0 0 0;
    div: nth-child(2) {
    position: relative;
    height: 15px;
    background: lightgray;
    width: 1px;
    align-self: center;
  }
  }
`;
const CardAction = styled.div`
  & {
    flex: 1;
    font-size: 22px;
    text-align: center;
    color: #C0C0C0;
    line-height: 22px;
    font-weight: 400;
    padding: 20px 0;
  }
`;

const HighLightSpan = styled.span`
  & {
    color: #ff0000;;
  }
`;
const SearchWrapper = styled.div`
  & {
    margin: 20px;
    border-radius: 4px;
    border: 1px solid #EAEDF7;
    background: white;
    display: flex;
    flex-direction: column;
    padding-bottom: 10px;
  }
`;
const SearchTitleWrapper = styled.div`
  & {
    display: flex;
    flex-direction: row;
    margin: 15px 20px 13px 20px;

    .searchTitle {
      font-size: 16px;
      font-family: SourceHanSansCN-Medium, SourceHanSansCN;
      font-weight: 500;
      color: #000000;
      line-height: 32px;
      flex: 1;
    }
  }
`;

const Line = styled.div`
  & {
    height: 0.5px;
    border: 1px solid #EAEDF7;
  }
`;
const ContentWrapper = styled.div`
  & {
    margin: 0 20px 20px 20px;
    border-radius: 4px;
    border: 1px solid #EAEDF7;
    background: white;
    display: flex;
    flex-direction: column;
  }
`;